import { useSelector } from "react-redux";

import { ExportWithMissingRolesDialog } from "Components/Actions/Export/ExportWithMissingRolesDialog";
import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { selectExportingProject } from "Store/Selectors/Export";
import { BaseDialog } from "Components/Generic/BaseDialog";
import { getName } from "Utils/Item";
import { ListNotExportableDialog } from "./ListNotExportableDialog";
import { UseExport } from "./UseExport";

export const Export = WithTranslator((props: IWithTranslatorProps): JSX.Element => {
  const { translator } = props;
  const exportingProject = useSelector(selectExportingProject);

  const {
    hideMissingRolesDialog,
    hideRequiredFieldsDialog,
    missingFieldsList,
    onConfirmMissingRolesDialog,
    onConfirmRequiredFieldsDialog,
    onDismissExport,
    onDismissMissingRolesDialog,
    onDismissRequiredFieldsDialog,
    showExportDialog
  } = UseExport();

  const title = exportingProject != null
    ? `${translator.get(`export`, `Project export`)}... - ${getName(exportingProject)}`
    : `${translator.get(`generic.done`, `Done`)}...`;

  return (
    <>
      <BaseDialog isOpen={showExportDialog} title={title} showCloseButton onDismiss={onDismissExport}>
        <span>
          {exportingProject != null
            && translator.get(
              `export.progress`,
              `Exporting project(s). You can continue working by closing the dialog. Otherwise the dialog will close automatically when the export is done. Do not leave the Construction HUB until you receive confirmation of successful export.`
            )}
        </span>
      </BaseDialog>
      <ExportWithMissingRolesDialog
        hidden={hideMissingRolesDialog}
        onConfirm={onConfirmMissingRolesDialog}
        onDismiss={onDismissMissingRolesDialog}
      />
      <ListNotExportableDialog
        hidden={hideRequiredFieldsDialog}
        missingFieldList={missingFieldsList}
        onConfirm={onConfirmRequiredFieldsDialog}
        onDismiss={onDismissRequiredFieldsDialog}
      />
    </>
  );
});

Export.displayName = `Export`;
